import { Routes } from '@angular/router';
import { Admin } from './pages/admin/admin';
import { keycloakGuard } from './guards/keycloak-guard';
import { Dashboard } from './pages/dashboard/dashboard';
import { Transactions } from './pages/transactions/transactions';
import { Checkouts } from './pages/checkouts/checkouts';
import { Clients } from './pages/clients/clients';
import { Users } from './pages/users/users';
import { Merchants } from './pages/merchants/merchants';
import { Settings } from './pages/settings/settings';
import { Logs } from './pages/logs/logs';
import { MqttMonitor } from './pages/mqtt-monitor/mqtt-monitor';
import { Estabelecimentos } from './pages/estabelecimentos/estabelecimentos';
import { Terminal } from './pages/checkouts/terminal/terminal';
import { Gerenciamento } from './pages/gerenciamento/gerenciamento';
import { Dev } from './pages/dev/dev';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    component: Dashboard,
    title: 'Dashboard',
  },
  { path: 'transactions', component: Transactions, title: 'Transações' },
  { path: 'estabelecimento', component: Estabelecimentos, title: 'Estabelecimentos' },
  {
    path: 'gerenciamento',
    component: Gerenciamento,
    title: 'Gerenciamento',
    children: [
      { path: 'checkout', component: Checkouts, title: 'Checkouts' },
      // { path: 'terminal', component: Terminal, title: 'Terminal' },
      { path: '', redirectTo: 'checkout', pathMatch: 'full' },
    ],
  },
  { path: 'checkout', component: Checkouts, title: 'Checkouts' },
  { path: 'settings', component: Settings, title: 'Configuração' },
  { path: 'dev', component: Dev, title: 'Desenvolvimento' },
  {
    path: 'admin',
    component: Admin,
    canActivate: [keycloakGuard],
    data: { role: ['admin'] },
    title: 'Administrativo',
    children: [
      { path: 'clientes', component: Clients },
      { path: 'logs', component: Logs },
      { path: 'mqttMonitor', component: MqttMonitor },
      { path: 'estabelecimentos/:label/:id', component: Merchants },
      { path: 'users/:label/:id', component: Users },
      { path: '', redirectTo: 'clientes', pathMatch: 'full' },
    ],
  },
];
